"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
const trimRegex = /^\/|\/$/g;
const trimPath = (path = '') => path.replace(trimRegex, '');
const trimPathNotFirst = (path = '', index) => (index === 0 ? path : path.replace(trimRegex, ''));
class UrlJoin {
    constructor(baseUrl, paths) {
        this.baseUrl = baseUrl;
        this.paths = paths;
        this.params = null;
    }
    toString() {
        const hasBaseUrl = this.baseUrl !== null && this.baseUrl !== undefined;
        let resultUrl = [this.baseUrl, ...this.paths]
            .filter(Boolean)
            .map(hasBaseUrl ? trimPath : trimPathNotFirst)
            .join(constants_1.DELIMITER_PATH);
        if (this.hasParams()) {
            const queryParams = Object.keys(this.params)
                .map(key => {
                return encodeURIComponent(key) + constants_1.DELIMITER_SEARCH_VALUES + encodeURIComponent(this.params[key]);
            })
                .join(constants_1.DELIMITER_SEARCH_PARAMS);
            resultUrl += constants_1.DELIMITER_URL_PARTS + queryParams;
        }
        return resultUrl;
    }
    queryParams(params) {
        this.params = params;
        return this;
    }
    hasParams() {
        return !!this.params && Object.keys(this.params).length > 0;
    }
}
exports.UrlJoin = UrlJoin;
